import phoneWithTopics2x from "~/images/landing/phone-with-topics@2x.png"
import phoneWithTopics3x from "~/images/landing/phone-with-topics@3x.png"
import phoneWithTopics4x from "~/images/landing/phone-with-topics@4x.png"
import { BREAKPOINTS, ResponsiveImage } from "../common/responsive-image"

export function PhoneImage() {
  return (
    <ResponsiveImage
      sources={[
        { media: BREAKPOINTS.mobile, src: phoneWithTopics2x },
        { media: BREAKPOINTS.tablet, src: phoneWithTopics3x },
        { media: BREAKPOINTS.desktop, src: phoneWithTopics4x },
      ]}
      fallbackSrc={phoneWithTopics3x}
      alt="Insider access to exclusive chats"
      className="mb-[-32px] max-md:pt-12 md:mb-[-64px] md:w-full md:max-w-[790px]"
    />
  )
}
